// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-12T17:57:57.462Z
// Property: Cornell Woods (ID: 6767906449166887)
// Collections: 19 amenities, 3 floorplans (live), 19 photos, 43 POIs, 4 reviews, 3 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166887",
  "property_external_id": "495795",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/cornell-woods-portland-or/80wx6p1/",
  "property_google_business_url": "https://www.google.com/maps/place/Cornell+Woods+Apartments/data=!4m2!3m1!1s0x0:0xe69e593fed3edd5?sa=X&ved=2ahUKEwjM5cXfh7ySAxUPQVUIHYZjBO0Q_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495795 p0505463",
  "property_status": null,
  "property_slug": "cornell-woods",
  "property_name": "Cornell Woods",
  "property_website_url": "https://www.portland-oregonapartments.com/",
  "property_domain": "https://www.portland-oregonapartments.com/",
  "property_address": "14682 Northwest Cornell Road",
  "property_full_address": "14682 NW Cornell Rd #1, Portland, OR 97229",
  "property_address_1": "14682 Northwest Cornell Road #1",
  "property_address_2": null,
  "property_address_city": "Portland",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97229",
  "property_address_country": "US",
  "property_address_county": "Washington County",
  "property_neighborhood_address": "Oak Hills",
  "property_address_latitude": "45.5314507",
  "property_address_longitude": "-122.8290019",
  "property_email": "cornellwoods@ctlmanagement.com",
  "property_phone": "18446249934",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Cornell Woods in Portland, OR, where modern living meets natural beauty. Choose from our stylish one, two, or three-bedroom floor plans, unwind by the swimming pool, or enjoy a family picnic in our vibrant courtyard. Your ideal home awaits—browse our availability or schedule a tour today!",
  "property_long_description": "Welcome to Cornell Woods, your serene sanctuary nestled in the heart of Portland, OR. Our vibrant apartment community offers a variety of thoughtfully designed floor plans, including stylish one-bedroom, spacious two-bedroom, and generous three-bedroom apartments that cater to your lifestyle needs. Each home features expansive layouts and ample storage with spacious closets, providing the perfect backdrop for your personal touch.\n\nAt Cornell Woods, we believe in enriching our residents' lives with an array of exceptional amenities. Dive into relaxation at our sparkling swimming pool, where sunny afternoons become cherished memories. For families, our community playground is the perfect spot for kids to play and make friends, while the charming courtyard equipped with picnic tables invites you to unwind outdoors or host gatherings with loved ones.\n\nStep outside onto your private deck or patio, where you can savor your morning coffee while soaking in the natural beauty that surrounds you. Enjoy the perfect blend of comfort and convenience, all within a welcoming community atmosphere.\n\nWhether you're seeking a cozy one-bedroom retreat, a spacious two-bedroom family home, or a three-bedroom haven for your growing needs, Cornell Woods has the perfect space for you. \n\nDon’t miss your chance to call Cornell Woods home! Find your new apartment today by browsing our availability or schedule a tour to experience the exceptional lifestyle we offer. Your new beginning awaits at Cornell Woods!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d2b40-ecfb-77da-8d41-9f2eefdbd801.webp",
  "property_featured_image_media": {
    "alt_text": "Cornell Woods Welcome Center exterior with landscaping",
    "public_id": "019d2b40-ecfb-77da-8d41-9f2eefdbd801",
    "storage_key": "property/6767906449166887/019d2b40-ecfb-77da-8d41-9f2eefdbd801.webp",
    "width": 1922,
    "height": 897
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "118",
  "property_year_built": "1979",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.76271186440678",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit (Refundable): $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $25 | Deposit $400",
  "property_online_leasing_url": "https://portland-oregonapartment.securecafe.com/onlineleasing/cornell-woods/guestlogin",
  "property_resident_portal_url": "https://portland-oregonapartment.securecafenet.com/residentservices/cornell-woods/userlogin",
  "property_apply_now_url": "https://portland-oregonapartments.securecafe.com/onlineleasing/cornell-woods/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019db148-7273-71b8-a879-0fab93f1d405.webp",
  "property_primary_logo_media": {
    "alt_text": "Cornell Woods Apartments logo",
    "public_id": "019db148-7273-71b8-a879-0fab93f1d405",
    "storage_key": "property/6767906449166887/019db148-7273-71b8-a879-0fab93f1d405.webp",
    "width": 710,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019db148-73c2-75d6-a7dd-bf9ee68bebc5.webp",
  "property_secondary_logo_media": {
    "alt_text": "Cornell Woods Apartments logo",
    "public_id": "019db148-73c2-75d6-a7dd-bf9ee68bebc5",
    "storage_key": "property/6767906449166887/019db148-73c2-75d6-a7dd-bf9ee68bebc5.webp",
    "width": 711,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019db148-7273-71b8-a879-0fab93f1d405.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cornell Woods Apartments logo",
    "public_id": "019db148-7273-71b8-a879-0fab93f1d405",
    "storage_key": "property/6767906449166887/019db148-7273-71b8-a879-0fab93f1d405.webp",
    "width": 710,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019db148-73c2-75d6-a7dd-bf9ee68bebc5.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cornell Woods Apartments logo",
    "public_id": "019db148-73c2-75d6-a7dd-bf9ee68bebc5",
    "storage_key": "property/6767906449166887/019db148-73c2-75d6-a7dd-bf9ee68bebc5.webp",
    "width": 711,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "592 - 776",
  "property_sqft_min": "592",
  "property_sqft_max": "776",
  "property_price_range": "1350 - 2365",
  "property_price_min": "1350",
  "property_price_max": "2365",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/cornellwoodsapartments/",
  "property_instagram_url": "https://www.instagram.com/cornellfarm.cafe/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJHScAXi0PlVQR1e3T_pPlaQ4",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/cornell-woods-apartments-portland",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cornell Woods",
  "property_home_romance_title": "Experience Joy in Every Corner of Your New Home",
  "property_home_amenities_blurb": "Welcome to Cornell Woods in Portland, OR—where modern living meets nature’s embrace. Choose from our stylish one, two, or three-bedroom layouts. Dive into our refreshing swimming pool, unwind on private decks, or enjoy family fun at the playground. Your perfect home awaits amidst spacious comfort and vibrant community life.",
  "property_home_floorplans_blurb": "At Cornell Woods in Portland, OR, each apartment home is designed with you in mind, blending contemporary comfort with nature's tranquility. From spacious layouts to cozy nooks, our diverse floor plans cater to your lifestyle. Browse our available options today and embrace your new beginning in this vibrant community.",
  "property_home_gallery_blurb": "Welcome to Cornell Woods, your Portland sanctuary where comfort meets elegance. Choose from inviting one, two, or three-bedroom floor plans, each featuring spacious closets and private decks. Delight in our inviting swimming pool, playground, and scenic courtyard with picnic tables. Picture yourself thriving in a vibrant community!",
  "property_home_neighborhood_blurb": "At Cornell Woods in Portland, OR, your ideal home awaits! Nestled amidst a vibrant neighborhood, you'll find the Oregon Zoo, the enchanting Portland Japanese Garden, and the historic Pittock Mansion just moments away. Enjoy an active lifestyle with top-notch athletic clubs and easy access to public transit.",
  "property_home_reviews_blurb": "Nestled in the heart of Portland, Cornell Woods offers a vibrant living experience. One resident raves, \"The sense of community here is unmatched.\" Dive into our resident reviews to uncover the charm and comfort that awaits you in your new home. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Cornell Woods in Portland, you'll find a vibrant blend of culture and recreation right at your doorstep. From the lush International Rose Test Garden to the innovative campuses of Nike and Intel, our community is surrounded by natural beauty and thriving industries. See what's nearby and immerse yourself in local treasures!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cornell Woods in Portland, OR, find your perfect sanctuary with one, two, or three-bedroom floor plans. Enjoy sunny afternoons by our swimming pool, family fun at the playground, and cozy gatherings in our serene courtyard with picnic tables. Unwind on private decks and relish spacious closets for all your essentials.",
  "property_applynow_blurb": "At Cornell Woods in Portland, OR, your ideal apartment awaits! Choose from one, two, or three-bedroom floor plans, each designed for comfort and style. Enjoy our refreshing swimming pool, inviting playground, and serene courtyard, complete with picnic tables. Leverage your private deck and spacious closets—apply online today!",
  "property_contactus_blurb": "At Cornell Woods in vibrant Portland, OR, our thoughtfully designed one, two, and three-bedroom apartments offer a perfect blend of comfort and style. Each spacious floor plan caters to diverse lifestyles and needs. Have questions? Reach out to our leasing team today and let us help you find your ideal home!",
  "property_faqs_blurb": "At Cornell Woods in Portland, OR, our diverse floor plans—one, two, and three bedrooms—accommodate every lifestyle. Got questions? Our FAQs page is brimming with insights and helpful information about our community. Dive in and uncover everything you need to know about your future home!",
  "property_floorplans_blurb": "Nestled in the heart of Portland, Cornell Woods offers thoughtfully designed one, two, and three-bedroom apartments that cater to your unique lifestyle. Embrace modern living with spacious layouts and inviting spaces. Browse our available apartment homes today and find the perfect floor plan that feels just like home!",
  "property_gallery_blurb": "At Cornell Woods in vibrant Portland, OR, our thoughtfully designed floor plans—ranging from one to three bedrooms—cater to your lifestyle. Enjoy sun-soaked moments by the swimming pool, laughter on the playground, or peaceful picnics in our scenic courtyard. Picture yourself living here, where comfort meets community!",
  "property_interactivemap_blurb": "At Cornell Woods in Portland, OR, your ideal living space awaits! Choose from one, two, or three-bedroom floor plans, all designed with comfort in mind. Enjoy sunny days by the swimming pool, picnicking in our courtyard, or relaxing on your private deck. Check out our interactive community map to start your journey today!",
  "property_pets_blurb": "At Cornell Woods in vibrant Portland, OR, your furry companions are part of the family! With a cozy environment for indoor cats and dogs under 25 lbs, our community is designed for pet lovers. Enjoy peaceful living with your small pets, and indulge in the charm of nearby parks!",
  "property_referafriend_blurb": "At Cornell Woods in Portland, OR, your dream home awaits! Choose from stylish one, two, or three-bedroom floor plans designed for comfort and convenience. Great friends make great neighbors—refer a friend today and enjoy the vibrant community together! Let’s create unforgettable memories at Cornell Woods!",
  "property_residentaccess_blurb": "Welcome to Cornell Woods in vibrant Portland, OR, where your ideal living space awaits! Choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Access your resident portal effortlessly to manage rent, schedule maintenance, and enjoy a seamless living experience in our thriving community!",
  "property_reviews_blurb": "At Cornell Woods in Portland, OR, our residents love calling this community home! One happy tenant shares, \"The peaceful atmosphere and friendly neighbors make every day enjoyable.\" Join our vibrant neighborhood and see why living here is a remarkable experience. Check out our reviews to hear more from our residents!",
  "property_created_at": "1762784768711",
  "property_scheduletour_blurb": "At Cornell Woods in Portland, OR, choose from our thoughtfully designed one, two, and three-bedroom apartments tailored for your lifestyle. Experience vibrant community living amid lush surroundings. Ready to envision your future home? Schedule a tour and read why our residents proudly call Cornell Woods their home sweet home! ",
  "property_thankyou_blurb": "Thank you for reaching out! At Cornell Woods in vibrant Portland, OR, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored for your lifestyle. Our team will be in touch soon to help you find your perfect home in the heart of nature and community. ",
  "property_virtualtours_blurb": "At Cornell Woods in Portland, OR, experience the perfect blend of comfort and style. Choose from our spacious one, two, and three-bedroom floor plans tailored to your lifestyle. Ready to envision your new home? Take a virtual tour and step into the vibrant community waiting for you!",
  "property_copyright": "2025 All Rights Reserved. Cornell Woods",
  "property_seo_title_home": "Cornell Woods |  Apartments in Portland, OR",
  "property_seo_description_home": "Discover Cornell Woods in Portland, OR! Choose from one, two, or three-bedroom apartments with amenities like a pool and playground. ",
  "property_seo_title_floorplans": "Floor Plans | Portland, OR Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Cornell Woods in Portland, OR. From cozy one-bedrooms to spacious three-bedrooms, browse our diverse floor plans today!",
  "property_seo_title_amenities": "Amenities | Portland, OR Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Cornell Woods in Portland, OR! Enjoy resort-style amenities like a pool, playground, and private patios. Find your perfect space today!",
  "property_seo_title_gallery": "Gallery | Apartments in Portland, OR",
  "property_seo_description_gallery": "Picture life at Cornell Woods in Portland, OR. With vibrant one-to-three bedroom plans, a pool, playground, and private patios, your perfect home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Cornell Woods Apartments",
  "property_seo_description_virtualtours": "Experience Cornell Woods in Portland, OR! Take a virtual tour of our inviting one, two, and three-bedroom apartments, and find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | Cornell Woods Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Cornell Woods in Portland, OR! Use our interactive map to explore spacious floor plans, amenities, and current availability today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Portland, OR",
  "property_seo_description_neighborhood": "Uncover the charm of Cornell Woods in Portland, OR. Dive into our neighborhood's local favorites and hidden gems just steps away from your new home.",
  "property_seo_title_contact": "Contact Us | Cornell Woods",
  "property_seo_description_contact": "Connect with Cornell Woods in Portland, OR, for your perfect floor plan! From cozy one-bedrooms to spacious three-bedrooms, our team is here to help you!",
  "property_seo_title_faqs": "FAQs | Apartments in Portland, OR",
  "property_seo_description_faqs": "Unearth answers to your queries at Cornell Woods in Portland, OR. From spacious floor plans to inviting amenities, our FAQs page has you covered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Portland, OR",
  "property_seo_description_reviews": "Experience the vibrant life at Cornell Woods in Portland, OR. Check out authentic resident reviews and discover why our community feels like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Portland, OR",
  "property_seo_description_applynow": "Discover charm at Cornell Woods, Portland! Spacious layouts and relaxing amenities await. Lease online and embrace comfort today!",
  "property_seo_title_residentaccess": "Resident Access | Cornell Woods",
  "property_seo_description_residentaccess": "Unlock convenience at Cornell Woods! Manage your rent, schedule maintenance, and connect with your community—all from our easy resident portal.",
  "property_seo_title_referafriend": "Refer A Friend | Cornell Woods",
  "property_seo_description_referafriend": "Refer a friend to Cornell Woods in Portland, OR! Great friends make great neighbors—share the joy of our vibrant community and enjoy exclusive rewards today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cornell Woods",
  "property_seo_description_scheduletour": "Experience Cornell Woods in Portland, OR—your tranquil oasis awaits. Schedule a tour today and envision the perfect blend of comfort and nature!",
  "property_seo_title_privacy": "Privacy Policy | Cornell Woods",
  "property_seo_description_privacy": "At Cornell Woods, Portland, your privacy matters. Review our policy to see how we protect your information and enhance your living experience.",
  "property_seo_title_accessibility": "Website Accessibility | Cornell Woods",
  "property_seo_description_accessibility": "Join us at Cornell Woods in Portland, OR, where we prioritize digital inclusion in a welcoming space that blends accessibility with comfort!",
  "property_seo_title_sitemap": "Sitemap | Cornell Woods",
  "property_seo_description_sitemap": "Navigate through Cornell Woods in Portland, OR! Access our sitemap to effortlessly find your way to the perfect home and community features.",
  "property_seo_title_thankyou": "Thank You | Cornell Woods",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to comfortable living at Cornell Woods in Portland starts now. Our team will connect with you soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Portland, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293637810",
  "amenities": [
    {
      "id": "ec_862e48eaf22ae3a690ae6db7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80428774",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-1feb-709c-83dd-c9f002278f5f.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and picnic tables.",
        "public_id": "019d496c-1feb-709c-83dd-c9f002278f5f",
        "storage_key": "property/6767906449166887/019d496c-1feb-709c-83dd-c9f002278f5f.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Cornell Woods seasonal swimming pool, Portland, OR, 97229",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f5f7b0f31895d283b9deb08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80428773",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-4948-719d-bfbf-0149b5826d28.webp",
      "amenity_image_media": {
        "alt_text": "Playground with colorful slides, tunnels, and climbing structures surrounded by trees and apartment buildings.",
        "public_id": "019d496c-4948-719d-bfbf-0149b5826d28",
        "storage_key": "property/6767906449166887/019d496c-4948-719d-bfbf-0149b5826d28.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Cornell Woods playground, Portland, OR, 97229",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d47b3043d805812fa3ce493f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80428769",
      "title": "Laundry Care Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6bbb0836da0d68337a04a2c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80428768",
      "title": "Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-730e-70dc-ac41-f028e41b9007.webp",
      "amenity_image_media": {
        "alt_text": "Garage building with multiple units and numbered doors.",
        "public_id": "019d496c-730e-70dc-ac41-f028e41b9007",
        "storage_key": "property/6767906449166887/019d496c-730e-70dc-ac41-f028e41b9007.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Cornell Woods garages, Portland, OR, 97229",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ccd944696e50349e1e90831",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80428771",
      "title": "On Bus Line",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13c974bcf579adf71c286ec5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80428772",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb939c317d912091501c491c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "120561384",
      "title": "Courtyard with Picnic Tables",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-4172-75e7-b7d4-5e02758b3a24.webp",
      "amenity_image_media": {
        "alt_text": "Picnic tables on gravel patch in grassy area with apartment buildings in background.",
        "public_id": "019d496c-4172-75e7-b7d4-5e02758b3a24",
        "storage_key": "property/6767906449166887/019d496c-4172-75e7-b7d4-5e02758b3a24.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Cornell Woods picnic area, Portland, OR, 97229",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a707e314957588f1a8a40da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "86462668",
      "title": "Package Acceptance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_849ab82e2ccd17ed250a552e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80428770",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_970c8408dd0d8101f5a8bdb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "86462670",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73a949bc54e310eed73dc87c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "82390144",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa75b15714716f92cca62dca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "82390145",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7f1f20f0d2f9638017fce9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80428777",
      "title": "In-Unit Washer & Dryer - In Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_635368b834e5f61f3636c7f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80428780",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d9a47-de76-75fc-85e5-47cdede11f5e.webp",
      "amenity_image_media": {
        "alt_text": "Exterior of apartment buildings with balconies and stone accents, surrounded by trees and grass.",
        "public_id": "019d9a47-de76-75fc-85e5-47cdede11f5e",
        "storage_key": "property/6767906449166887/019d9a47-de76-75fc-85e5-47cdede11f5e.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Patios and decks at Cornell Woods apartments overlooking green space with trees",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_598d995f6c1d0cb8eb45d8ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80428781",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5d96eac19ea360b02884fdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "127612503",
      "title": "Upgraded Kitchen Cabinets and Appliances - In Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a70de7f655c97d4347d4c3db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "87310407",
      "title": "Kitchen Pantry - In Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d0b63aedf385465ac2824d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80428779",
      "title": "Linen Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e00b9fd31d720ef401e5c25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "yardi",
      "external_id": "80683641",
      "title": "High Speed Internet Accessible",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_f27699223cbed56bedb91c70",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d42a3-98e2-710e-ade9-ab8380fe62d8.webp",
      "image_media": {
        "alt_text": "Cornell Woods Apartments monument sign with colorful flowers.",
        "public_id": "019d42a3-98e2-710e-ade9-ab8380fe62d8",
        "storage_key": "property/6767906449166887/019d42a3-98e2-710e-ade9-ab8380fe62d8.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome to Cornell Woods Apartments, a beautiful community with a welcoming monument sign surrounded by vibrant flowers and lush greenery.",
      "link": "false",
      "alt_text": "Cornell Woods Apartments monument sign with colorful flowers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_MonumentSign.jpg"
    },
    {
      "id": "ec_398d87e20c4757004be13726",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496b-f3b9-70b5-98a7-f44a35c9b799.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel refrigerator, white cabinets, quartz countertops, and stainless steel sink.",
        "public_id": "019d496b-f3b9-70b5-98a7-f44a35c9b799",
        "storage_key": "property/6767906449166887/019d496b-f3b9-70b5-98a7-f44a35c9b799.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, quartz countertops, and ample cabinet space for all your culinary needs.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel refrigerator, white cabinets, quartz countertops, and stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_Vacant2x1Kitchen.jpg"
    },
    {
      "id": "ec_2c1519f85a020dc03428fbd7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-017d-705d-9657-3ac8271ee2a9.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment living area and kitchen.",
        "public_id": "019d496c-017d-705d-9657-3ac8271ee2a9",
        "storage_key": "property/6767906449166887/019d496c-017d-705d-9657-3ac8271ee2a9.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "View of a spacious living area with wood-look flooring, leading into a modern kitchen with white cabinetry and a sleek faucet.",
      "link": "false",
      "alt_text": "Interior view of an apartment living area and kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_Vacant2x1DiningRoom.jpg"
    },
    {
      "id": "ec_2e9e9f1b87782b66b9a0098b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496b-f3c2-705f-a78e-66d546794097.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment.",
        "public_id": "019d496b-f3c2-705f-a78e-66d546794097",
        "storage_key": "property/6767906449166887/019d496b-f3c2-705f-a78e-66d546794097.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious living room with carpeted floors and an open view to the kitchen area. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "Living room and kitchen area in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_Vacant2x1DiningRoomLivingRoom.jpg"
    },
    {
      "id": "ec_bd93018e7827ac69c7f61844",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496b-f3c1-7418-9cc2-74b619491a12.webp",
      "image_media": {
        "alt_text": "Empty living room with sliding glass door and carpet.",
        "public_id": "019d496b-f3c1-7418-9cc2-74b619491a12",
        "storage_key": "property/6767906449166887/019d496b-f3c1-7418-9cc2-74b619491a12.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious and carpeted living area with a sliding glass door leading to the outdoors, perfect for your new home.",
      "link": "false",
      "alt_text": "Empty living room with sliding glass door and carpet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_Vacant2x1LivingRoomSlider.jpg"
    },
    {
      "id": "ec_18ba165403c51d28b006c22f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496b-f3ba-71e0-8c5a-01ec4a6f3303.webp",
      "image_media": {
        "alt_text": "Empty room with beige carpet and light gray walls, view into a hallway.",
        "public_id": "019d496b-f3ba-71e0-8c5a-01ec4a6f3303",
        "storage_key": "property/6767906449166887/019d496b-f3ba-71e0-8c5a-01ec4a6f3303.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious and carpeted room with light gray walls, a closed closet, and a view into a connecting hallway.",
      "link": "false",
      "alt_text": "Empty room with beige carpet and light gray walls, view into a hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_Vacant2x1PrimaryBedroom.jpg"
    },
    {
      "id": "ec_b2473c3c565b913bd16862fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-1acd-7718-ac42-b327c3a4c69f.webp",
      "image_media": {
        "alt_text": "Empty room with neutral walls and carpet, and a large window overlooking the property exterior.",
        "public_id": "019d496c-1acd-7718-ac42-b327c3a4c69f",
        "storage_key": "property/6767906449166887/019d496c-1acd-7718-ac42-b327c3a4c69f.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious and neutral living space, perfect for personalizing. Features a large window with views of the community's exterior.",
      "link": "false",
      "alt_text": "Empty room with neutral walls and carpet, and a large window overlooking the property exterior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_Vacant2x1SecondBedroom.jpg"
    },
    {
      "id": "ec_ad08f77be2467af0ff56eed5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-1e4d-762f-94ea-679abbe90303.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and bathtub with shower.",
        "public_id": "019d496c-1e4d-762f-94ea-679abbe90303",
        "storage_key": "property/6767906449166887/019d496c-1e4d-762f-94ea-679abbe90303.webp",
        "width": 1463,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully updated bathroom, featuring a spacious vanity with ample storage, a modern sink, and a clean, crisp toilet. The bathtub and shower combo provides a relaxing retreat.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, sink, toilet, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_Vacant2x1Bathroom.jpg"
    },
    {
      "id": "ec_28675dbd836eabfe0296fdee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08aa-b975-735b-9d0a-7cc21780c41e.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, oven, sink, and wooden countertops.",
        "public_id": "019d08aa-b975-735b-9d0a-7cc21780c41e",
        "storage_key": "property/6767906449166887/019d08aa-b975-735b-9d0a-7cc21780c41e.webp",
        "width": 640,
        "height": 480
      },
      "title": "Apartment",
      "description": "A functional kitchen space featuring essential appliances, ample counter space, and a window for natural light.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, oven, sink, and wooden countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_OriginalKitchen.jpg"
    },
    {
      "id": "ec_db417d68dcb0c56a937c192c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08aa-b969-74a4-ad58-900c13112023.webp",
      "image_media": {
        "alt_text": "Living room with sofa, chairs, coffee table, and TV.",
        "public_id": "019d08aa-b969-74a4-ad58-900c13112023",
        "storage_key": "property/6767906449166887/019d08aa-b969-74a4-ad58-900c13112023.webp",
        "width": 640,
        "height": 424
      },
      "title": "Apartment",
      "description": "Spacious living room with comfortable seating, a coffee table, and a mounted TV, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room with sofa, chairs, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_VacantLivingRoom.jpg"
    },
    {
      "id": "ec_a8890b6ef6067a8281ced3ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-1f17-73af-bf98-ac6b29f868df.webp",
      "image_media": {
        "alt_text": "Exterior of the Welcome Center building with an American flag.",
        "public_id": "019d496c-1f17-73af-bf98-ac6b29f868df",
        "storage_key": "property/6767906449166887/019d496c-1f17-73af-bf98-ac6b29f868df.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "The welcoming exterior of the Welcome Center building at Cornell Woods, featuring a pristine lawn and lush landscaping.",
      "link": "false",
      "alt_text": "Exterior of the Welcome Center building with an American flag.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_WelcomeCenter.jpg"
    },
    {
      "id": "ec_1d814a4a4927bc383611c477",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-1feb-709c-83dd-c9f002278f5f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and picnic tables.",
        "public_id": "019d496c-1feb-709c-83dd-c9f002278f5f",
        "storage_key": "property/6767906449166887/019d496c-1feb-709c-83dd-c9f002278f5f.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush greenery and convenient seating areas for relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and picnic tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_SeasonalSwimmingPool.jpg"
    },
    {
      "id": "ec_72f31f161950b98d058cb077",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-2559-737c-a261-d9de22c8c5c5.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d496c-2559-737c-a261-d9de22c8c5c5",
        "storage_key": "property/6767906449166887/019d496c-2559-737c-a261-d9de22c8c5c5.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, surrounded by lush trees and comfortable lounge seating. Enjoy a refreshing dip on a sunny day.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_SeasonalSwimmingPoolPlayground.jpg"
    },
    {
      "id": "ec_248b9899c71113c239c0d0f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-4948-719d-bfbf-0149b5826d28.webp",
      "image_media": {
        "alt_text": "Playground with colorful slides, tunnels, and climbing structures surrounded by trees and apartment buildings.",
        "public_id": "019d496c-4948-719d-bfbf-0149b5826d28",
        "storage_key": "property/6767906449166887/019d496c-4948-719d-bfbf-0149b5826d28.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, a perfect spot for children to play and explore amidst the scenic surroundings of our apartment complex.",
      "link": "false",
      "alt_text": "Playground with colorful slides, tunnels, and climbing structures surrounded by trees and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_Playground(1).jpg"
    },
    {
      "id": "ec_134c0fcdcfefaddc5813d260",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-4172-75e7-b7d4-5e02758b3a24.webp",
      "image_media": {
        "alt_text": "Picnic tables on gravel patch in grassy area with apartment buildings in background.",
        "public_id": "019d496c-4172-75e7-b7d4-5e02758b3a24",
        "storage_key": "property/6767906449166887/019d496c-4172-75e7-b7d4-5e02758b3a24.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation with picnic tables available for residents amidst lush greenery and mature trees.",
      "link": "false",
      "alt_text": "Picnic tables on gravel patch in grassy area with apartment buildings in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_PicnicArea.jpg"
    },
    {
      "id": "ec_24c971f9c3204bcf7d639c19",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-525b-71bc-bba7-d1b57ee69ee2.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with manicured lawn and mature trees.",
        "public_id": "019d496c-525b-71bc-bba7-d1b57ee69ee2",
        "storage_key": "property/6767906449166887/019d496c-525b-71bc-bba7-d1b57ee69ee2.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy the lush green spaces and mature trees surrounding your apartment home. Relax on the manicured lawn or picnic at the outdoor seating area.",
      "link": "false",
      "alt_text": "Apartment building exterior with manicured lawn and mature trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_GreenSpace.jpg"
    },
    {
      "id": "ec_24cda5da590047a68472e58d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-55cf-7589-9ddd-08f1d0273d0c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot and trees.",
        "public_id": "019d496c-55cf-7589-9ddd-08f1d0273d0c",
        "storage_key": "property/6767906449166887/019d496c-55cf-7589-9ddd-08f1d0273d0c.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with a parking lot and trees. Offers a glimpse of the property's setting and architecture.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with a parking lot and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_ParkingLot.jpg"
    },
    {
      "id": "ec_ef2644a895b74273576338e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-682a-71eb-9ccb-3f2c633475e6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with stone accents and stairs.",
        "public_id": "019d496c-682a-71eb-9ccb-3f2c633475e6",
        "storage_key": "property/6767906449166887/019d496c-682a-71eb-9ccb-3f2c633475e6.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Discover comfortable living in these apartment buildings featuring natural stone accents and convenient exterior stair access.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with stone accents and stairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_TwoandThreeStoryBuildings.jpg"
    },
    {
      "id": "ec_d913827ce81cb3292c78b08b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d496c-730e-70dc-ac41-f028e41b9007.webp",
      "image_media": {
        "alt_text": "Garage building with multiple units and numbered doors.",
        "public_id": "019d496c-730e-70dc-ac41-f028e41b9007",
        "storage_key": "property/6767906449166887/019d496c-730e-70dc-ac41-f028e41b9007.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Secure garage parking available for residents. Provides convenient and protected storage for vehicles.",
      "link": "false",
      "alt_text": "Garage building with multiple units and numbered doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CornellWoods_Portland_OR_Garages(1).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_47281bb6-300d-4fd0-8b5d-c863a0e6fef1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Topgolf Hillsboro",
      "poi_type": "Restaurants",
      "poi_address": "5505 NE Huffman St, Hillsboro, OR 97124, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with heated bays, a variety of games, and tasty appetizers. They highlight the affordable prices and relaxed atmosphere, suitable for families and groups. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-f0dc-748a-90fc-426643b7412a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f0dc-748a-90fc-426643b7412a",
        "storage_key": "property/6767906449166887/019d08ab-f0dc-748a-90fc-426643b7412a.webp",
        "width": 1000,
        "height": 686
      },
      "poi_business_url": "https://topgolf.com/us/hillsboro/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5590872944195421069&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-hillsboro",
      "poi_latitude": "45.55978169999999",
      "poi_longitude": "-122.9240849",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-549-5197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6",
        "storage_key": "property/6767906449166887/019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtY7HRqQFlVQRjUMcL1LFlk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fb305e7d-3b4e-4bb3-98ae-0d0079de4d23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "10657 SW Beaverton Hillsdale Hwy, Beaverton, OR 97005, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, nuggets, and waffle fries. They highlight the reasonable prices, convenient location, and ample parking. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-f110-76dc-a506-3b11cfe0a50f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f110-76dc-a506-3b11cfe0a50f",
        "storage_key": "property/6767906449166887/019d08ab-f110-76dc-a506-3b11cfe0a50f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/or/raleigh-hills?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=16597217422825337868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "45.4869133",
      "poi_longitude": "-122.7862333",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-305-9158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6",
        "storage_key": "property/6767906449166887/019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9onNxANlVQRDLRta08pVeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d5ae720b-5eff-41f1-83db-6bf71d43975a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "9309 SW Washington Square Rd, Tigard, OR 97223, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "Diners say this restaurant offers a wide variety of dishes, including Bang Bang Chicken and Shrimp, cheesecake, and pasta, with many praising the extensive menu and delicious food. They also highlight the friendly and attentive service, and the vibrant and comfortable atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-f0e9-74cd-9e6b-0338c1a194d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f0e9-74cd-9e6b-0338c1a194d1",
        "storage_key": "property/6767906449166887/019d08ab-f0e9-74cd-9e6b-0338c1a194d1.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/or/tigard-101.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=9275120421759837335&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "45.4510321",
      "poi_longitude": "-122.7823753",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-620-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6",
        "storage_key": "property/6767906449166887/019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6omzVcMlVQRl2T3w-HYt4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_41117744-3c93-4bf9-97a7-d838bb8d0feb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "BGs Food Cartel",
      "poi_type": "Restaurants",
      "poi_address": "4250 SW Rose Biggi Ave, Beaverton, OR 97005, USA",
      "poi_short_description": "Open-air space with over 30 international food trucks, plus an indoor/outdoor speakeasy-style bar.",
      "poi_long_description": "People say this restaurant offers tasty brisket, pork fried rice, and potstickers. They highlight the generous portions, the variety of food trucks, and the family-friendly atmosphere with a kids' play area and ample seating. They also like the clean restrooms and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-f132-73a6-98a5-922a4e1a8351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f132-73a6-98a5-922a4e1a8351",
        "storage_key": "property/6767906449166887/019d08ab-f132-73a6-98a5-922a4e1a8351.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bgfoodcartel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13359900484536572783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bgs-food-cartel",
      "poi_latitude": "45.4892645",
      "poi_longitude": "-122.8081145",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-605-9163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6",
        "storage_key": "property/6767906449166887/019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJSQIYZ8OlVQRbxtf97TmZ7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ca133e1b-6783-4f36-a5ed-24738f05da28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Din Tai Fung",
      "poi_type": "Restaurants",
      "poi_address": "9724 SW Washington Square Rd, Tigard, OR 97223, USA",
      "poi_short_description": "Upscale eatery specializing in Taiwanese dumplings with soup, steamed dumplings, noodle dishes, fried rice and rice cakes.",
      "poi_long_description": "People say this Chinese restaurant serves delicious soup dumplings, garlic green beans, and noodles. They highlight the fast service and friendly staff. They also like the clean and modern atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-fa1f-7477-b455-b8abef65c192.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fa1f-7477-b455-b8abef65c192",
        "storage_key": "property/6767906449166887/019d08ab-fa1f-7477-b455-b8abef65c192.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://dtf.com/en/locations/tigard",
      "poi_directions_map_url": "https://maps.google.com/?cid=7925850032975282981&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "din-tai-fung",
      "poi_latitude": "45.4486876",
      "poi_longitude": "-122.7813741",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-768-9888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6",
        "storage_key": "property/6767906449166887/019d08ab-9cb1-74ca-90cd-ebbbf3a5a1d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJra5u8yENlVQRJYOCrpxG_m0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_96d8244f-72eb-4c33-86cf-7b5b02dce226",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Washington Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "9585 SW Washington Square Rd, Portland, OR 97223, USA",
      "poi_short_description": "Large shopping center with a variety of department stores, specialty shops & food options.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and services, including a Cheesecake Factory, a Lego store, and a variety of clothing stores. They also highlight the clean and well-maintained environment, the friendly and helpful staff, and the convenient parking.\n\nOther reviews mention the food court can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-fa1f-7477-b455-b5dde1ebb55f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fa1f-7477-b455-b5dde1ebb55f",
        "storage_key": "property/6767906449166887/019d08ab-fa1f-7477-b455-b5dde1ebb55f.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.shopwashingtonsquare.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=8036230870585529003&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "washington-square",
      "poi_latitude": "45.4502491",
      "poi_longitude": "-122.7812183",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-639-8860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a2c8-7126-bf06-961c43d80718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a2c8-7126-bf06-961c43d80718",
        "storage_key": "property/6767906449166887/019d08ab-a2c8-7126-bf06-961c43d80718.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy9M2zVcMlVQRq1JHJmZthm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_00c17e99-3007-4df7-86be-f8df0003d766",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Uwajimaya Beaverton",
      "poi_type": "Shopping & Retail",
      "poi_address": "10500 SW Beaverton Hillsdale Hwy, Beaverton, OR 97005, USA",
      "poi_short_description": "Perennial Asian grocery stocking meats, produce & prepared foods, plus gifts & home goods.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh seafood, produce, and Japanese groceries, including musubi, onigiri, and poke. They highlight the friendly and helpful staff, and the fun, unique shopping experience. They also like the bookstore in the back and the delicious hot food options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-fb04-7448-aa01-ca52e2cdcd76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fb04-7448-aa01-ca52e2cdcd76",
        "storage_key": "property/6767906449166887/019d08ab-fb04-7448-aa01-ca52e2cdcd76.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.uwajimaya.com/visit/beaverton/?utm_source=localprofiles&utm_medium=organic&utm_content=beaverton&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=6570527899701517362&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uwajimaya-beaverton",
      "poi_latitude": "45.48564529999999",
      "poi_longitude": "-122.7849074",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-643-4512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-9cb1-74ca-90cd-f01ce8b6035d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9cb1-74ca-90cd-f01ce8b6035d",
        "storage_key": "property/6767906449166887/019d08ab-9cb1-74ca-90cd-f01ce8b6035d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVB9wAQMlVQRMpyACFA0L1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_3a8f64f9-f506-48e7-9fe1-d04c86a35c4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Columbia Sportswear Company Employee Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "14100 NW Science Park Dr, Portland, OR 97229, USA",
      "poi_short_description": "Spacious shop carrying jackets, hoodies and other mountain-ready pieces from Patagonia, Sorel and prAna.",
      "poi_long_description": "People say this sportswear store offers a wide selection of products from brands like Columbia, Mountain Hardwear, and Sorel. They highlight the great deals and discounts, especially for those with employee access, and the clean, well-organized layout. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-fb17-75ef-9970-09069d5f8ddd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fb17-75ef-9970-09069d5f8ddd",
        "storage_key": "property/6767906449166887/019d08ab-fb17-75ef-9970-09069d5f8ddd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.columbia.com/or/portland/employee-store-425",
      "poi_directions_map_url": "https://maps.google.com/?cid=2313366469886134804&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "columbia-sportswear-company-employee-store",
      "poi_latitude": "45.5261922",
      "poi_longitude": "-122.8234194",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 503-985-4125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a2c8-7126-bf06-961c43d80718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a2c8-7126-bf06-961c43d80718",
        "storage_key": "property/6767906449166887/019d08ab-a2c8-7126-bf06-961c43d80718.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbxyE2yoPlVQRFMrcMIy6GiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_ff6a4d7a-3caf-43f7-861c-44b688d5ef9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Adidas Employee Store Portland",
      "poi_type": "Shopping & Retail",
      "poi_address": "2701 NW Vaughn St Suite 209, Portland, OR 97210, USA",
      "poi_short_description": "Retail store featuring the brand's signature athletic footwear, clothes & accessories.",
      "poi_long_description": "People say this sportswear store offers a wide selection of Adidas shoes, apparel, and exclusive items. They also highlight the great discounts, friendly and helpful staff, and clean, well-organized store.\n\nOther reviews mention the checkout line can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-01bb-743a-ac2b-d081859167ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-01bb-743a-ac2b-d081859167ec",
        "storage_key": "property/6767906449166887/019d08ac-01bb-743a-ac2b-d081859167ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://go.adidas.com/ihha/11c0ab86",
      "poi_directions_map_url": "https://maps.google.com/?cid=8112365766255068035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adidas-employee-store-portland",
      "poi_latitude": "45.5375454",
      "poi_longitude": "-122.7078005",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 971-234-8536",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a2c8-7126-bf06-961c43d80718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a2c8-7126-bf06-961c43d80718",
        "storage_key": "property/6767906449166887/019d08ab-a2c8-7126-bf06-961c43d80718.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_S0kNQPNqkERg0Os6a7plHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_e4f02ba2-6712-4e09-aee1-2c0eaf215e22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "3025 SW Cedar Hills Blvd, Beaverton, OR 97005, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide selection of groceries, including a large bulk section, and fresh produce. They also highlight the affordable prices, convenient 24-hour service, and friendly staff.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-2db2-7189-9fee-46fbaedcdac6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-2db2-7189-9fee-46fbaedcdac6",
        "storage_key": "property/6767906449166887/019d08ab-2db2-7189-9fee-46fbaedcdac6.webp",
        "width": 1280,
        "height": 744
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15287079724831147658&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "45.49809399999999",
      "poi_longitude": "-122.810114",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-644-4940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-9cb1-74ca-90cd-f01ce8b6035d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9cb1-74ca-90cd-f01ce8b6035d",
        "storage_key": "property/6767906449166887/019d08ab-9cb1-74ca-90cd-f01ce8b6035d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk19IebsOlVQRigaj6wOeJtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_3fff10f5-522b-450e-ac10-c1706ff8e624",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "University of Portland",
      "poi_type": "Education",
      "poi_address": "5000 N Willamette Blvd, Portland, OR 97203, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-0278-76fc-a17a-05279f20e3c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0278-76fc-a17a-05279f20e3c6",
        "storage_key": "property/6767906449166887/019d08ac-0278-76fc-a17a-05279f20e3c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.up.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=798014410561283040&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-portland",
      "poi_latitude": "45.5732046",
      "poi_longitude": "-122.7275712",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 503-943-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a25f-76c9-a527-665f4d480cb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a25f-76c9-a527-665f4d480cb5",
        "storage_key": "property/6767906449166887/019d08ab-a25f-76c9-a527-665f4d480cb5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSXgea4unlVQR4OMl2-AdEws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5f78bee9-fe0f-4361-85a8-859885de6314",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Beaverton City Library",
      "poi_type": "Education",
      "poi_address": "12375 SW 5th St, Beaverton, OR 97005, USA",
      "poi_short_description": "Multistory library with kids' areas, computers and board game rentals.",
      "poi_long_description": "People say this public library offers a wide selection of books, music CDs, DVDs/Blu-rays, and video games, as well as digital resources and a \"Library of Things.\" They highlight the spacious layout, beautiful architecture, and numerous working, studying, and reading spaces, including a dedicated children's area with storytime rooms. They also like the friendly and helpful staff, and the various activities and events for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-029b-740f-af51-86b8012ddf53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-029b-740f-af51-86b8012ddf53",
        "storage_key": "property/6767906449166887/019d08ac-029b-740f-af51-86b8012ddf53.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://beavertonlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2456838086164544331&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-city-library",
      "poi_latitude": "45.4840984",
      "poi_longitude": "-122.804071",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-644-2197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a25f-76c9-a527-665f4d480cb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a25f-76c9-a527-665f4d480cb5",
        "storage_key": "property/6767906449166887/019d08ab-a25f-76c9-a527-665f4d480cb5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv_YnSyAMlVQRS_t89DhxGCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_274431b2-d8f3-460c-8cb6-b8a793ecd252",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Portland Community College Rock Creek",
      "poi_type": "Education",
      "poi_address": "17705 NW Springville Rd, Portland, OR 97229, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-037c-765b-a54d-e62c2e5eccae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-037c-765b-a54d-e62c2e5eccae",
        "storage_key": "property/6767906449166887/019d08ac-037c-765b-a54d-e62c2e5eccae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pcc.edu/about/locations/rock-creek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3966148189600444475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-community-college-rock-creek",
      "poi_latitude": "45.5668982",
      "poi_longitude": "-122.8604923",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 971-722-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a25f-76c9-a527-665f4d480cb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a25f-76c9-a527-665f4d480cb5",
        "storage_key": "property/6767906449166887/019d08ab-a25f-76c9-a527-665f4d480cb5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzascJg8GlVQRO3Cxz8OWCjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d8edbdaf-ad4d-49bc-8c90-a2ffb666f598",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Hillsboro Brookwood Library",
      "poi_type": "Education",
      "poi_address": "2850 NE Brookwood Pkwy, Hillsboro, OR 97124, USA",
      "poi_short_description": "Duck pond, quiet rooms, books and musical instruments are all offered at this library.",
      "poi_long_description": "People say this public library offers a wide selection of books, movies, and tools, as well as reservable study rooms, a Collaboratory, and free access to online resources. They highlight the beautiful building with scenic views, the clean and updated facilities, and the many options for study and community activities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-0874-759b-950b-87cb1820718e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0874-759b-950b-87cb1820718e",
        "storage_key": "property/6767906449166887/019d08ac-0874-759b-950b-87cb1820718e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wccls.org/libraries/hillsborobrookwood",
      "poi_directions_map_url": "https://maps.google.com/?cid=12017357779366618812&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillsboro-brookwood-library",
      "poi_latitude": "45.542883",
      "poi_longitude": "-122.9360009",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-615-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a25f-76c9-a527-665f4d480cb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a25f-76c9-a527-665f4d480cb5",
        "storage_key": "property/6767906449166887/019d08ab-a25f-76c9-a527-665f4d480cb5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJswhUZ24FlVQRvKbsyTo7xqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_c8cfc4d8-fdc5-49be-ad46-dbcf3fbb68e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Oregon Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4001 SW Canyon Rd, Portland, OR 97221, USA",
      "poi_short_description": "64-acre zoo featuring elephants, polar bears & other animal exhibits emphasizing conservation.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, polar bears, giraffes, and lions, and features a popular baby elephant. They highlight the well-maintained exhibits, the spacious and natural habitats, and the fun train ride. They also like the family-friendly atmosphere and the knowledgeable staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-0a51-714f-9dff-9170cf22de97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0a51-714f-9dff-9170cf22de97",
        "storage_key": "property/6767906449166887/019d08ac-0a51-714f-9dff-9170cf22de97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.oregonzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16710360885333195814&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oregon-zoo",
      "poi_latitude": "45.5093572",
      "poi_longitude": "-122.714291",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-226-1561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbhWuC4KlVQRJvzdnrAg5-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_522a06d3-be2b-4181-8c71-f518e5672a42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Pittock Mansion",
      "poi_type": "Entertainment",
      "poi_address": "3229 NW Pittock Dr, Portland, OR 97210, USA",
      "poi_short_description": "23-room mansion from 1914 now a museum, featuring gardens, period furnishings & scenic views.",
      "poi_long_description": "People say this local history museum offers breathtaking views of the city and Mount Hood, and features a historic mansion with period furniture and decor. They highlight the beautifully maintained grounds, gardens, and hiking trails, and the informative self-guided tour. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-4de5-710f-9a46-de52bad4eeac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4de5-710f-9a46-de52bad4eeac",
        "storage_key": "property/6767906449166887/019d08ab-4de5-710f-9a46-de52bad4eeac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pittockmansion.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13828917755801354490&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pittock-mansion",
      "poi_latitude": "45.5252061",
      "poi_longitude": "-122.7162689",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-823-3623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a73e-738e-8ec0-3fc3d8dd51cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a73e-738e-8ec0-3fc3d8dd51cf",
        "storage_key": "property/6767906449166887/019d08ab-a73e-738e-8ec0-3fc3d8dd51cf.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJU2_QC5IJlVQR-sChHm4v6r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_804abdd3-cf2f-4e31-bdb9-b002ad7a9190",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Witch's Castle",
      "poi_type": "Entertainment",
      "poi_address": "Lower Macleay Trail, Portland, OR 97210, USA",
      "poi_short_description": "On the Lower Macleay Trail, this old stone building with no roof is surrounded by dense woodland.",
      "poi_long_description": "People say this historical landmark offers a short, scenic hike to a castle. They also highlight the graffiti adds to the unique and mysterious atmosphere, and the trail is easy and enjoyable for all ages.\n\nOther reviews mention the castle can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-69d6-725c-834f-6ba6ca4779c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-69d6-725c-834f-6ba6ca4779c0",
        "storage_key": "property/6767906449166887/019d08ab-69d6-725c-834f-6ba6ca4779c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portlandoregon.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16975484436389670400&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "witchs-castle",
      "poi_latitude": "45.5283626",
      "poi_longitude": "-122.7250661",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-823-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09XitZYJlVQRAK4tqScJles",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_290a9852-dd0d-4024-9ded-2a7d2d42c0ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Chiles Center",
      "poi_type": "Entertainment",
      "poi_address": "5000 N Willamette Blvd, Portland, OR 97203, USA",
      "poi_short_description": "Events venue, including for sports, as well as commencements.",
      "poi_long_description": "People say this arena is a great place to attend high school graduations and basketball games, with comfortable seating and good views of the stage. They also highlight the family-friendly atmosphere, reasonably-priced concessions, and helpful staff.\n\nSome reviews mention parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-0dd0-7069-915a-b5a3c43e75d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0dd0-7069-915a-b5a3c43e75d5",
        "storage_key": "property/6767906449166887/019d08ac-0dd0-7069-915a-b5a3c43e75d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://portlandpilots.com/sports/2008/8/11/MBB_0811084643.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3803296177795868573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chiles-center",
      "poi_latitude": "45.5750931",
      "poi_longitude": "-122.7284971",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 503-943-7525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62homIunlVQRnacfFbkFyDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_6df3be31-444d-496f-b68c-da202d847e91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Hillsboro Stadium",
      "poi_type": "Entertainment",
      "poi_address": "4450 NE Century Blvd, Hillsboro, OR 97124, USA",
      "poi_short_description": "Sports stadium with concerts, graduation, and other events, as well as wheelchair seating.",
      "poi_long_description": "People say this stadium offers remarkable baseball and softball fields, and a grass area for families to relax. They highlight the reasonable prices, good atmosphere, and clean facilities. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-0f8e-766a-9aa6-095ea936c2cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0f8e-766a-9aa6-095ea936c2cf",
        "storage_key": "property/6767906449166887/019d08ac-0f8e-766a-9aa6-095ea936c2cf.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "http://www.hillsboro-oregon.gov/departments/parks-recreation/our-facilities/gordon-faber-recreation-complex",
      "poi_directions_map_url": "https://maps.google.com/?cid=9475876756446806181&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillsboro-stadium",
      "poi_latitude": "45.5543523",
      "poi_longitude": "-122.9070216",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-681-6120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-471b-7074-8021-0d6d106716f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-471b-7074-8021-0d6d106716f5",
        "storage_key": "property/6767906449166887/019d08ac-471b-7074-8021-0d6d106716f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr_ABr5cFlVQRpYBkY7QTgYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_18316b1c-3158-4aeb-81d0-4ace096105a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "600 SW 116th Ave, Portland, OR 97225, USA",
      "poi_short_description": "Athletic country club chain in Cedar Mill with a gym, an outdoor beach club, pools, basketball and pickleball courts, and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of classes, top-notch equipment, and multiple pools, including an adults-only option, and provides convenient amenities like a cafe, lounge, and clean locker rooms with saunas and plunge pools.\n\nOther reviews mention the price can be high and the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-5e1b-7078-896c-cf9d1de91906.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-5e1b-7078-896c-cf9d1de91906",
        "storage_key": "property/6767906449166887/019d08ab-5e1b-7078-896c-cf9d1de91906.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/or/beaverton.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=8291423413939196135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "45.5153662",
      "poi_longitude": "-122.7940413",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-616-9950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ88xwwvQJlVQR59AzRqoNEXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6ab63764-f42d-42a4-8501-f9db7acaacf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1265 NW Waterhouse Ave, Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of classes, including Zumba, and has friendly staff and instructors.\n\nOther reviews mention the facilities can be crowded and the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-1218-7649-8a37-802c9f75f394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-1218-7649-8a37-802c9f75f394",
        "storage_key": "property/6767906449166887/019d08ac-1218-7649-8a37-802c9f75f394.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/beaverton-or/tanasbourne-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=11710869471339348612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "45.5275512",
      "poi_longitude": "-122.8373563",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-207-0452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV0wx9jkPlVQRhAImwrxdhaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0feb2281-5837-4416-b41e-6f6f42080b3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Villa Sport Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "13900 SW Meridian St, Beaverton, OR 97005, USA",
      "poi_short_description": "Large, resort-like, family-oriented recreation center featuring a gym, plus numerous clean pools (indoors and out), a hot tub and a sauna.",
      "poi_long_description": "People say this gym offers a variety of pools, fitness classes, and amenities, including a steam room, sauna, and hot tubs. They also highlight the family-friendly vibe, the dedicated instructors, and the welcoming staff.\n\nOther reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-139a-73bd-9a23-b241d1dd6388.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-139a-73bd-9a23-b241d1dd6388",
        "storage_key": "property/6767906449166887/019d08ac-139a-73bd-9a23-b241d1dd6388.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.villasport.com/beaverton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6712726625660967216&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "villa-sport-athletic-club",
      "poi_latitude": "45.5039949",
      "poi_longitude": "-122.8247248",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 971-317-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaSSIqMEOlVQRMBnU7ExlKF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a1797a39-b714-4343-96c7-baf82b193866",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8235 SW Apple Way, Portland, OR 97225, USA",
      "poi_short_description": "Large fitness center featuring ample cardio machines, tanning beds and hydro-massage loungers, plus clean showers.",
      "poi_long_description": "People say this gym offers a wide selection of equipment, including hack squat, vertical leg press, and four Smith machines, and most lockers already have locks. They highlight the spacious layout, clean facilities, and the availability of machines even during peak hours. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-1579-720f-9933-d0457ae1203d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-1579-720f-9933-d0457ae1203d",
        "storage_key": "property/6767906449166887/019d08ac-1579-720f-9933-d0457ae1203d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/portland-raleigh-hills-or?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2165421477037240221&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.4859322",
      "poi_longitude": "-122.7625921",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-477-4107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwYVFIqgLlVQRnW_OR1wfDR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0a6942c5-7357-4812-841b-339bdd764786",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2800 SW Hocken Ave, Beaverton, OR 97005, USA",
      "poi_short_description": "Chain offering treadmills, swimming pools. basketball courts and strength equipment.",
      "poi_long_description": "People say this gym offers a pool and swim aerobic classes.\n\nOther reviews mention the facility can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-1794-72be-89f6-f97240a3501d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-1794-72be-89f6-f97240a3501d",
        "storage_key": "property/6767906449166887/019d08ac-1794-72be-89f6-f97240a3501d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=324&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12600149306380626618&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "45.4994817",
      "poi_longitude": "-122.8128318",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-627-0737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0dUPA7wOlVQRuqqzIwm53K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_193ffbb7-aa9d-43a2-8012-75850a09da82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "11040 NE Evergreen Pkwy, Beaverton, OR 97006, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-18b8-733b-b779-c3ead5b35cca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-18b8-733b-b779-c3ead5b35cca",
        "storage_key": "property/6767906449166887/019d08ac-18b8-733b-b779-c3ead5b35cca.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/beaverton-or-493",
      "poi_directions_map_url": "https://maps.google.com/?cid=14167829038459972431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "45.5357141",
      "poi_longitude": "-122.8656296",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-466-0206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VU02UMPlVQRT-veM3I9nsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_862f5092-25ba-4863-a8b6-b0cda7501ceb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Tanasbourne Veterinary Emergency",
      "poi_type": "Health and Wellness",
      "poi_address": "17400 NW Corridor Ct, Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-1cf2-77a8-b9f0-e59f1ee46b4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-1cf2-77a8-b9f0-e59f1ee46b4c",
        "storage_key": "property/6767906449166887/019d08ac-1cf2-77a8-b9f0-e59f1ee46b4c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.tanasbourneveter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10792964979161014890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tanasbourne-veterinary-emergency",
      "poi_latitude": "45.536718",
      "poi_longitude": "-122.8560594",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-629-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn9EvFGUPlVQRaqIfCHdQyJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_0c6a63af-c0f8-42b3-a36c-c089c89dea69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Providence St. Vincent Hospital East Pavilion",
      "poi_type": "Health and Wellness",
      "poi_address": "9155 SW Barnes Rd, Portland, OR 97225, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-2145-74f9-9b74-f28433a246f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2145-74f9-9b74-f28433a246f5",
        "storage_key": "property/6767906449166887/019d08ac-2145-74f9-9b74-f28433a246f5.webp",
        "width": 1280,
        "height": 815
      },
      "poi_business_url": "https://oregon.providence.org/location-directory/p/providence-st-vincent-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5100053104868075598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "providence-st-vincent-hospital-east-pavilion",
      "poi_latitude": "45.510411",
      "poi_longitude": "-122.7701193",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-216-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-ad46-733f-a770-46c8aeb6c8df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-ad46-733f-a770-46c8aeb6c8df",
        "storage_key": "property/6767906449166887/019d08ab-ad46-733f-a770-46c8aeb6c8df.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQXvYkMJlVQRTihKE0cHx0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1368f655-df47-43a1-9ac4-794dade65bc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Providence St. Vincent Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9205 SW Barnes Rd, Portland, OR 97225, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-56db-7124-a161-490387d52432.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-56db-7124-a161-490387d52432",
        "storage_key": "property/6767906449166887/019d08ab-56db-7124-a161-490387d52432.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.providence.org/locations/or/st-vincent-medical-center?ls=location&y_source=1_OTU3NjM5Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1736548786178364168&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "providence-st-vincent-medical-center",
      "poi_latitude": "45.5103299",
      "poi_longitude": "-122.7720125",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-216-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-ad46-733f-a770-46c8aeb6c8df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-ad46-733f-a770-46c8aeb6c8df",
        "storage_key": "property/6767906449166887/019d08ab-ad46-733f-a770-46c8aeb6c8df.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QPVf0QJlVQRCBNMn-t1GRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6af0d005-1a1d-4e5a-af1d-b90356aef826",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Portland Japanese Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "611 SW Kingston Ave, Portland, OR 97205, USA",
      "poi_short_description": "Many styles of gardens showcased in serene 5.5-acre space with waterfall, teahouse & mountain view.",
      "poi_long_description": "People say this garden offers stunning scenery, beautiful bonsai, and a peaceful atmosphere. They highlight the relaxing and serene vibe, and the well-maintained grounds with water features, koi ponds, and a waterfall. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-50e0-723e-b562-ccfefb66de11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-50e0-723e-b562-ccfefb66de11",
        "storage_key": "property/6767906449166887/019d08ab-50e0-723e-b562-ccfefb66de11.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://japanesegarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11424717693547273965&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-japanese-garden",
      "poi_latitude": "45.5188634",
      "poi_longitude": "-122.7080354",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-223-1321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a7ed-75d7-a591-43268df1e4c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7ed-75d7-a591-43268df1e4c5",
        "storage_key": "property/6767906449166887/019d08ab-a7ed-75d7-a591-43268df1e4c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJecbtFYoJlVQR7V4BJzbAjJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_e6d24d65-97c4-4419-bb90-2832e1b850a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "International Rose Test Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 SW Kingston Ave, Portland, OR 97205, USA",
      "poi_short_description": "City-maintained rose test gardens founded in 1917, featuring 10,000+ plants in manicured displays.",
      "poi_long_description": "People say this garden offers a stunning variety of roses, with vibrant colors and intoxicating fragrances. They highlight the peaceful and serene atmosphere, and the beautiful views of the city and mountains. They also like the free admission and the availability of a free shuttle. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-7170-755f-975e-fd786ca3440c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-7170-755f-975e-fd786ca3440c",
        "storage_key": "property/6767906449166887/019d08ab-7170-755f-975e-fd786ca3440c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portland.gov/parks/washington-park-international-rose-test-garden",
      "poi_directions_map_url": "https://maps.google.com/?cid=10519281268788551622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "international-rose-test-garden",
      "poi_latitude": "45.5189524",
      "poi_longitude": "-122.7052686",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-823-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a7ed-75d7-a591-43268df1e4c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7ed-75d7-a591-43268df1e4c5",
        "storage_key": "property/6767906449166887/019d08ab-a7ed-75d7-a591-43268df1e4c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfarJiIoJlVQRxt-PlpT--5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_9675373e-21fd-4a55-ad55-bbd54986791d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Hoyt Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4000 SW Fairview Blvd, Portland, OR 97221, USA",
      "poi_short_description": "190-acre park with thousands of native, global & endangered trees, plus 12 miles of hiking trails.",
      "poi_long_description": "People say this arboretum offers a wide variety of trees and plants, including redwoods, and well-maintained trails for hiking. They highlight the peaceful and beautiful atmosphere, and the clearly labeled paths. They also like the helpful staff and the convenient amenities, such as restrooms, a gift shop, and a free shuttle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-5190-70e2-935f-963295c626c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-5190-70e2-935f-963295c626c1",
        "storage_key": "property/6767906449166887/019d08ab-5190-70e2-935f-963295c626c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hoytarboretum.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=c38e859c-b096-4ae9-b3a9-551f21ba189e",
      "poi_directions_map_url": "https://maps.google.com/?cid=132726812224680572&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hoyt-arboretum",
      "poi_latitude": "45.5162616",
      "poi_longitude": "-122.7152124",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-865-8733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a7ed-75d7-a591-43268df1e4c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7ed-75d7-a591-43268df1e4c5",
        "storage_key": "property/6767906449166887/019d08ab-a7ed-75d7-a591-43268df1e4c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8cJu-ocJlVQRfHLSHlWK1wE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_d91e46a5-c946-4bab-9547-34b2b0568eea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Washington Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4033 SW Canyon Rd, Portland, OR 97221, USA",
      "poi_short_description": "Huge park with varied attractions including zoo, rose garden, Japanese garden & 12 miles of trails.",
      "poi_long_description": "People say this park offers a beautiful rose garden, Japanese garden, and arboretum, as well as hiking trails, tennis courts, and a playground. They highlight the peaceful and relaxing atmosphere, and the free shuttle service. They also like the stunning views and the opportunity to enjoy nature.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-2571-711e-9191-13a52046fa82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2571-711e-9191-13a52046fa82",
        "storage_key": "property/6767906449166887/019d08ac-2571-711e-9191-13a52046fa82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://explorewashingtonpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7944369892695267707&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "washington-park",
      "poi_latitude": "45.5151756",
      "poi_longitude": "-122.7104903",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-319-0999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a7ed-75d7-a591-43268df1e4c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7ed-75d7-a591-43268df1e4c5",
        "storage_key": "property/6767906449166887/019d08ab-a7ed-75d7-a591-43268df1e4c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGfTXCycKlVQRe9loilMSQG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e146ddbf-36fa-4370-b20d-a91849d9cac8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "RedTail Golf Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8200 SW Scholls Ferry Rd, Beaverton, OR 97008, USA",
      "poi_short_description": "Golf center at an 18-hole course offering practice facilities, lessons, a pro shop & an eatery.",
      "poi_long_description": "People say this golf course offers a well-stocked pro shop, a driving range with TrackMan technology, and professional lessons. They also highlight the friendly and helpful staff, and the quick turnaround for services like regripping.\n\nOther reviews mention the course can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-27a8-728b-afc2-a79fe1981cf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-27a8-728b-afc2-a79fe1981cf4",
        "storage_key": "property/6767906449166887/019d08ac-27a8-728b-afc2-a79fe1981cf4.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://golfredtail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15748737038652720950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "redtail-golf-center",
      "poi_latitude": "45.4608887",
      "poi_longitude": "-122.778375",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-646-5166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-ad38-75be-a4f0-4e242d72b48a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-ad38-75be-a4f0-4e242d72b48a",
        "storage_key": "property/6767906449166887/019d08ab-ad38-75be-a4f0-4e242d72b48a.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJTYBlhF4MlVQRNsfuceXAjto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_fba14b21-aee9-4f2d-b9b6-f26bde99291f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Hillsboro Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3355 NE Cornell Rd, Hillsboro, OR 97124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-26c6-706a-9d2c-de5506976195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-26c6-706a-9d2c-de5506976195",
        "storage_key": "property/6767906449166887/019d08ac-26c6-706a-9d2c-de5506976195.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.portofportland.com/HIO",
      "poi_directions_map_url": "https://maps.google.com/?cid=6464888335436437604&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillsboro-airport",
      "poi_latitude": "45.5329479",
      "poi_longitude": "-122.9479571",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-693-1963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-47b8-7165-a16a-cb6ad4036fe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-47b8-7165-a16a-cb6ad4036fe1",
        "storage_key": "property/6767906449166887/019d08ac-47b8-7165-a16a-cb6ad4036fe1.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJwXsGe1sFlVQRZFhBSrDlt1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_8b390739-666f-4bfa-bcc8-3c84443ac5a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Beaverton TC MAX Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-29da-7218-967c-99fb2b082b25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-29da-7218-967c-99fb2b082b25",
        "storage_key": "property/6767906449166887/019d08ac-29da-7218-967c-99fb2b082b25.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?id=9821",
      "poi_directions_map_url": "https://maps.google.com/?cid=13913915888813031590&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-tc-max-station",
      "poi_latitude": "45.4914575",
      "poi_longitude": "-122.8016546",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ7Mt6YOlVQRpkBdI8goGME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_17b5277f-2792-4aaa-9050-355bfb0006e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Quatama",
      "poi_type": "Transportation & Transit",
      "poi_address": "350 SW 205th Ave, Hillsboro, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-2f61-720d-998d-0507d1779a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2f61-720d-998d-0507d1779a6d",
        "storage_key": "property/6767906449166887/019d08ac-2f61-720d-998d-0507d1779a6d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?stop_id=9833",
      "poi_directions_map_url": "https://maps.google.com/?cid=2211718111633100831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quatama",
      "poi_latitude": "45.523201",
      "poi_longitude": "-122.888821",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfph5J8PlVQRH1Awg-eZsR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_47ab2e13-796e-42e5-b4ee-d12c191adc8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Orenco MAX",
      "poi_type": "Transportation & Transit",
      "poi_address": "Hillsboro, OR 97124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-3020-763b-a5fe-248baa0b9b28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3020-763b-a5fe-248baa0b9b28",
        "storage_key": "property/6767906449166887/019d08ac-3020-763b-a5fe-248baa0b9b28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?stop_id=9835",
      "poi_directions_map_url": "https://maps.google.com/?cid=13474446335283984598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "orenco-max",
      "poi_latitude": "45.530296",
      "poi_longitude": "-122.9158316",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-238-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSFaAoYPlVQR1niqH43Z_ro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_0ce5186e-4ec2-4627-87a1-f6e3fe6e9b7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Elmonica/SW 170th Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-30a9-70bc-a205-150717e79370.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-30a9-70bc-a205-150717e79370",
        "storage_key": "property/6767906449166887/019d08ac-30a9-70bc-a205-150717e79370.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?id=9829",
      "poi_directions_map_url": "https://maps.google.com/?cid=12242366764481047543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elmonicasw-170th-ave",
      "poi_latitude": "45.5099231",
      "poi_longitude": "-122.8515139",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-c6QOOMOlVQR9-vwnrWf5ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_b9f1dd94-9d6c-407d-aeb9-c13ccf98772d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Nike World Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Bowerman Dr, Beaverton, OR 97005, USA",
      "poi_short_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_long_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-8061-73e3-b04f-8aacb5091dc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8061-73e3-b04f-8aacb5091dc3",
        "storage_key": "property/6767906449166887/019d08ab-8061-73e3-b04f-8aacb5091dc3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://about.nike.com/pages/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=12026902182619501264&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike-world-headquarters",
      "poi_latitude": "45.5075349",
      "poi_longitude": "-122.8272752",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-671-6453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbaRNTcIOlVQR0NJnV9Aj6KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2dcaf97c-4c13-4f21-9f9d-700b773c60eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Intel Gordon Moore Park at Ronler Acres",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 NE Century Blvd, Hillsboro, OR 97124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-80ae-709c-8f50-34be5fa6356d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-80ae-709c-8f50-34be5fa6356d",
        "storage_key": "property/6767906449166887/019d08ab-80ae-709c-8f50-34be5fa6356d.webp",
        "width": 1280,
        "height": 997
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8328745523481169069&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-gordon-moore-park-at-ronler-acres",
      "poi_latitude": "45.54101319999999",
      "poi_longitude": "-122.9168708",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 408-765-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28RnPXkFlVQRrUy4D-2llXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5a5a6bca-71d1-42d5-9b30-ce1df33af175",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Intel Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Ronler Acres 3, 2501 NE Century Blvd, Hillsboro, OR 97124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-38eb-719d-9871-657e3abf81be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-38eb-719d-9871-657e3abf81be",
        "storage_key": "property/6767906449166887/019d08ac-38eb-719d-9871-657e3abf81be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14911434154982632404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-corporation",
      "poi_latitude": "45.5452239",
      "poi_longitude": "-122.9126512",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 607-761-6281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGS6CxHgFlVQR1OtdG1wO8M4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_10762938-2618-4d7b-91c0-613fae5f88d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Intel RA4 Main Lobby",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3100 NE Stucki Ave, Hillsboro, OR 97124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-39f4-709f-88b5-95d920f71e28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-39f4-709f-88b5-95d920f71e28",
        "storage_key": "property/6767906449166887/019d08ac-39f4-709f-88b5-95d920f71e28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3713851987025361628&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-ra4-main-lobby",
      "poi_latitude": "45.5417436",
      "poi_longitude": "-122.8726584",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuXTybsQFlVQR3HoGk7RAijM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dffc169d-1de5-4422-81e9-d6b6cb1d6b4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "poi_name": "Daimler Truck North America (TEC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "TEC, 4747 N Channel Ave, Portland, OR 97217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ac-3d12-725a-bab7-c456cd48658b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3d12-725a-bab7-c456cd48658b",
        "storage_key": "property/6767906449166887/019d08ac-3d12-725a-bab7-c456cd48658b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://northamerica.daimlertruck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12085477051079676782&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daimler-truck-north-america-tec",
      "poi_latitude": "45.5564842",
      "poi_longitude": "-122.7057232",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 39 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 503-745-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a8a1-737d-b87a-c4d05b639649",
        "storage_key": "property/6767906449166887/019d08ab-a8a1-737d-b87a-c4d05b639649.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu-eUknunlVQRblO9qlg9uKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_d1d0b0f8-974d-44ee-ab93-d54c7c701ed9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_07e4fe8c-e934-4f71-8242-4dacd3181a01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_035ad83c-c6f9-463b-a3b0-0c9f03a46cb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_dc525138-f424-4fef-bbe0-edb1e5968711",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_03757c2f-58cb-420b-ab34-ffe6e9d7eb92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_9907be9f-ff20-4ee3-bed5-3278bf0a2652",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_dd003ca4-71f5-4fc0-bd9e-682071cfa470",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_14ea123c-62e0-4fcf-8fca-241cbde9fd23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "rating": "5.0",
      "name": "Aneesa John",
      "text": "I have lived here for almost 6 years now, and I can confidently say that it has been a great 6 years. Maintenance is always on top of it and are so readily equipped to help at almost any hour of the day. The manager Thelmi  is personable and very communicative. These apartments home such a diverse community of people. I also really appreciate how safe I feel here. 10/10 would recommend these apartments to people who are looking to live alone, with roommates, and even with families.",
      "date": "2025-10-15",
      "title": ""
    },
    {
      "id": "custom_1db30621-effa-4c11-bc64-dd90bd868895",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "rating": "5.0",
      "name": "Brandi Reese",
      "text": "In the two years I’ve lived here I have been consistently impressed with the quality work and professionalism of the management and maintenance team. They’ve been professional, responsive and thorough. They have helped build a sense of community through resident appreciation events and creative contests. This small group of people strives to be a friendly, reliable and engaging presence and their work makes a positive impact. In addition, the landscaping is lovely. There are grassy areas and a lot of well maintained mature trees that provide shade from the summer heat. The location is convenient, the living space is comfortable for my family and the people are friendly. It’s a good place to call home.",
      "date": "2025-08-26",
      "title": ""
    },
    {
      "id": "custom_8b347860-0f4c-42b6-a8a7-040299bcb83d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "rating": "5.0",
      "name": "Aine Williams",
      "text": "I have lived at Cornell Woods Apartments since October of 2023. I am so happy here. I just love the apartment manager Thelmi and the maintenance supervisor Jake. They are both professional and very efficient while treating residents kindly and with respect as they provide excellent customer service. In fact at times they both have gone above and beyond to assist my family, work with us and help us to feel at home. The complex is clean, tidy and very well maintained. I feel extremely safe in this apartment community and would recommend Cornell Woods to anyone looking to move into this area!\n\nThanks so much Thelmi and Jake! You both make our experience here so much better!!!  Have a great weekend, you deserve it! 😊",
      "date": "2025-07-18",
      "title": ""
    },
    {
      "id": "custom_2e8f652e-10e3-475e-a5ed-f52ff0033d15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "rating": "5.0",
      "name": "Diana Wong",
      "text": "We lived at Cornell Woods for 6 years and had the best experience! The complex is situated amongst big trees which makes it a peaceful haven and community. Management is great with upkeep of the apartments and improvement projects keep the complex new and in good condition. Work orders for the apartment were completed quickly so we always had our apartment in tip top shape (shoutout to Jesse!) we love Thelmi too as she is kind, sweet and funny and quick to respond.\nThe neighbors were nice and respectful and we always felt very safe.",
      "date": "2024-12-10",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_91989a95-7c90-4823-a41a-f636c9f7ba4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d2b3f-b91e-7362-87a5-063c2bc87d73.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b3f-b91e-7362-87a5-063c2bc87d73",
        "storage_key": "property/6767906449166887/019d2b3f-b91e-7362-87a5-063c2bc87d73.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cornell Woods Apartments 1 Bedroom 1 Bath 592 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YnQ4u1ruphL"
    },
    {
      "id": "custom_2e65df09-6859-466a-9635-ff0617086b40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d2b3f-da86-7704-960f-13325c251465.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b3f-da86-7704-960f-13325c251465",
        "storage_key": "property/6767906449166887/019d2b3f-da86-7704-960f-13325c251465.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cornell Woods Apartments  - 2 Bedroom 1 Bath 776 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kKzB37qAix7"
    },
    {
      "id": "custom_b7c00c44-6c1f-4811-8033-42e653f667a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166887/019d2b3f-f8b1-704c-bc57-32b9ce3ea8ab.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b3f-f8b1-704c-bc57-32b9ce3ea8ab",
        "storage_key": "property/6767906449166887/019d2b3f-f8b1-704c-bc57-32b9ce3ea8ab.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cornell Woods Apartments - 3 Bedroom 1 Bath 943 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cZmj2MAJEH3"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1a2-ab8d-758b-9cdd-9fd95e1a2538",
      "lead_source": "LANDING_PAGE",
      "name": "Cornell Woods Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "apartments-with-swimming-pool-portland-or-cornell-woods",
      "search_query": "apartments with swimming pool Portland OR",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool in Portland, OR",
      "h2_subtitle": "Discover the perfect escape at Cornell Woods, featuring a refreshing swimming pool amidst Portland's serene surroundings.",
      "page_copy": "If you're on the hunt for apartments with swimming pool Portland OR, Cornell Woods is the place to be. Located in the vibrant Oak Hills neighborhood, our community provides a peaceful retreat with top-notch amenities, including a well-maintained swimming pool perfect for unwinding on sunny days. \n\nBeyond the pool, residents enjoy spacious closets, private decks or patios, and a playful courtyard with picnic tables and a playground. With all these features, plus a prime location in Washington County, Cornell Woods offers an unparalleled living experience in Portland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Swimming Pool in Portland, OR",
      "seo_description": "Discover Cornell Woods, a serene apartment community in Portland, OR, featuring a refreshing swimming pool and more! Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "family-friendly-apartments-playground-washington-county-cornell-woods",
      "search_query": "family-friendly apartments with playground Washington County",
      "category": "Amenity",
      "h1_title": "Family-Friendly Apartments in Washington County",
      "h2_subtitle": "Experience family-friendly living at Cornell Woods with a dedicated playground located in Washington County.",
      "page_copy": "Searching for family-friendly apartments with playground Washington County? Look no further than Cornell Woods, where families are at the heart of our community. Nestled in the Oak Hills neighborhood of Portland, OR, our apartments are designed with families in mind, featuring a safe and fun playground right on the grounds for kids to enjoy endless playtime.\n\nIn addition to the playground, Cornell Woods offers spacious closets, private decks, and a welcoming courtyard with picnic tables, perfect for family gatherings or quiet relaxation. Our commitment to family-friendly living sets us apart, making Cornell Woods the ideal choice for those seeking a vibrant community in Washington County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apartments in Washington County",
      "seo_description": "Discover Cornell Woods, a family-friendly community in Washington County, offering a dedicated playground and more amenities for the whole family.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "courtyard-apartments-picnic-area-oak-hills-cornell-woods",
      "search_query": "courtyard apartments with picnic area Oak Hills",
      "category": "Amenity",
      "h1_title": "Courtyard Apartments in Oak Hills",
      "h2_subtitle": "Enjoy peaceful living at Cornell Woods' courtyard apartments with a picnic area, located in the charming Oak Hills neighborhood.",
      "page_copy": "For those seeking courtyard apartments with picnic area Oak Hills, Cornell Woods offers an inviting solution. Situated in the serene Oak Hills area of Portland, our community features beautifully landscaped courtyards complete with picnic tables, creating the ideal setting for outdoor dining and socializing.\n\nOur thoughtfully designed apartments boast spacious closets and private decks or patios, ensuring a comfortable lifestyle. Families can enjoy the on-site playground, while everyone can relax by the refreshing swimming pool. With these amenities, Cornell Woods provides a welcoming atmosphere for those who appreciate both community and tranquility in Washington County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Courtyard Apartments in Oak Hills",
      "seo_description": "Explore Cornell Woods in Oak Hills, featuring courtyard apartments with a picnic area and family-friendly amenities like a playground and swimming pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "private-decks-patios-apartments-portland-97229-cornell-woods",
      "search_query": "private decks patios apartments Portland 97229",
      "category": "Amenity",
      "h1_title": "Private Decks and Patios in Portland 97229",
      "h2_subtitle": "Discover the charm of Cornell Woods' apartments with private decks and patios in Portland's 97229 area.",
      "page_copy": "If you're looking for private decks patios apartments Portland 97229, Cornell Woods is your ideal destination. Our community is located in the peaceful neighborhood of Oak Hills, providing residents with private decks or patios, perfect for enjoying the serene Portland weather.\n\nIn addition to these private outdoor spaces, our apartments feature spacious closets and share community amenities such as a courtyard with picnic tables, a playground for families, and a refreshing swimming pool. Situated in the heart of Portland's 97229, Cornell Woods combines privacy with a vibrant community atmosphere, offering a comprehensive living experience in Washington County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Private Decks and Patios in Portland 97229",
      "seo_description": "Find private decks and patios apartments at Cornell Woods in Portland 97229. Enjoy outdoor spaces and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "spacious-closets-apartments-northwest-cornell-road-cornell-woods",
      "search_query": "spacious closets apartments near Northwest Cornell Road",
      "category": "Amenity",
      "h1_title": "Spacious Closets Apartments on NW Cornell Road",
      "h2_subtitle": "Cornell Woods features apartments near Northwest Cornell Road with ample storage solutions, including spacious closets.",
      "page_copy": "Looking for spacious closets apartments near Northwest Cornell Road? Cornell Woods offers exceptional living in a convenient Northwest Portland location. Our apartments provide expansive closet spaces, ideal for accommodating all your storage needs, ensuring a clutter-free lifestyle.\n\nSituated near Oak Hills, residents enjoy easy access to local amenities while relishing the tranquility of our community. Beyond spacious closets, enjoy private decks, a vibrant courtyard with picnic areas, and family-friendly amenities such as a playground and swimming pool. Make Cornell Woods your new home and experience the perfect blend of comfort and practicality near Northwest Cornell Road.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Closets Apartments on NW Cornell Road",
      "seo_description": "Explore Cornell Woods near Northwest Cornell Road. Spacious closets, private decks, and family-friendly amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-oak-hills-or-cornell-woods",
      "search_query": "one bedroom apartments oak hills or",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Oak Hills, OR",
      "h2_subtitle": "Discover one bedroom apartments in Oak Hills, OR at Cornell Woods, where comfort meets convenience in a tranquil setting.",
      "page_copy": "If you're searching for one bedroom apartments Oak Hills OR, look no further than Cornell Woods. Nestled in the serene Oak Hills neighborhood of Portland, our one-bedroom apartments offer a peaceful retreat while providing all the essentials for comfortable living.\n\nResidents of Cornell Woods enjoy spacious interiors, complete with ample storage through our spacious closets, as well as private decks or patios. Our community features beneficial amenities such as a courtyard with picnic tables, a swimming pool, and a playground. Ideal for those who value both privacy and community, our one-bedroom apartments in Oak Hills OR provide the perfect balance for any lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Oak Hills, OR",
      "seo_description": "Find one bedroom apartments in Oak Hills, OR at Cornell Woods. Enjoy community amenities and tranquil living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-portland-or-cornell-woods",
      "search_query": "two bedroom apartments portland or",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Portland, OR",
      "h2_subtitle": "Explore the comfortable two bedroom apartments in Portland, OR at Cornell Woods, perfect for a family or roommate setup.",
      "page_copy": "Cornell Woods offers ideal two bedroom apartments in Portland, OR, catering to those seeking spacious and comfortable living. Located in the welcoming Oak Hills neighborhood, our apartments feature ample room along with spacious closets, perfect for family living or sharing with a roommate.\n\nDesigned with community in mind, residents enjoy exclusive access to amenities such as private decks or patios, a delightful courtyard with picnic tables, a playground, and a swimming pool. Perfectly situated in Washington County, Cornell Woods provides a peaceful atmosphere while ensuring convenient access to all Portland has to offer. Choose our two bedroom apartments for a balanced blend of privacy and community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Portland, OR",
      "seo_description": "Discover two bedroom apartments in Portland, OR at Cornell Woods. Spacious living and community amenities in Oak Hills neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-washington-county-cornell-woods",
      "search_query": "three bedroom apartments washington county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Washington County",
      "h2_subtitle": "Find spacious three bedroom apartments in Washington County at Cornell Woods, an ideal choice for families or those needing extra space.",
      "page_copy": "Cornell Woods presents exceptional three bedroom apartments in Washington County, perfect for those who need extra space without compromising on comfort. Located in the charming Oak Hills neighborhood of Portland, our three-bedroom units provide spacious living areas complemented by large closets for all your storage needs.\n\nAs a resident at Cornell Woods, you'll enjoy private decks or patios that offer a peaceful retreat, as well as access to our community amenities like a playground, swimming pool, and courtyard with picnic tables. Experience the best of suburban living with the convenience of nearby city amenities. Our three-bedroom apartments are designed to accommodate families and individuals seeking a balanced lifestyle in Washington County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Washington County",
      "seo_description": "Explore three bedroom apartments in Washington County at Cornell Woods. Perfect for families with plentiful amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-portland-cornell-woods",
      "search_query": "apartments near University of Portland OR",
      "category": "School",
      "h1_title": "Apartments Near University of Portland, OR",
      "h2_subtitle": "Explore convenient apartments near the University of Portland OR, at Cornell Woods, ideal for students or faculty seeking comfortable living.",
      "page_copy": "Cornell Woods offers convenient apartments near University of Portland OR, making it an ideal choice for students and faculty alike. Located in the peaceful Oak Hills neighborhood, our community provides easy access to the university, combining the tranquility of suburban living with academic proximity.\n\nOur residents enjoy spacious interiors with ample storage solutions like spacious closets, and private outdoor areas such as decks or patios. Community amenities include a swimming pool, playground, and a courtyard with picnic tables, perfect for relaxation after a day on campus. Experience a supportive living environment that meets both educational and lifestyle needs at Cornell Woods.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Portland, OR",
      "seo_description": "Discover apartments near University of Portland OR at Cornell Woods. Ideal for students and faculty with ample amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "cornell-woods-apartments-near-pcc-rock-creek",
      "search_query": "Cornell Woods apartments close to Portland Community College Rock Creek",
      "category": "School",
      "h1_title": "Cornell Woods Near PCC Rock Creek",
      "h2_subtitle": "Discover Cornell Woods apartments close to Portland Community College Rock Creek. Ideal for students and staff seeking convenient living.",
      "page_copy": "Cornell Woods apartments offer an exceptional location close to Portland Community College Rock Creek, making them an optimal choice for students, faculty, and staff seeking a convenient place to live. Nestled in the tranquil Oak Hills neighborhood, our apartment community not only provides easy access to PCC Rock Creek but also a serene environment ideal for studying or relaxing after a busy day.\n\nResidents of Cornell Woods enjoy modern comforts, including spacious closets and private decks or patios. The community boasts amenities such as a playground, a refreshing swimming pool, and a courtyard featuring picnic tables. These apartments are beautifully positioned in Washington County, providing a perfect balance of educational proximity and residential comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cornell Woods Near PCC Rock Creek",
      "seo_description": "Explore Cornell Woods apartments close to Portland Community College Rock Creek. Perfect for students and staff with nearby amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "apartments-near-providence-st-vincent-hospital-cornell-woods",
      "search_query": "apartments near Providence St. Vincent Hospital East Pavilion Portland",
      "category": "Hospital",
      "h1_title": "Apartments Near Providence St. Vincent Hospital",
      "h2_subtitle": "Find ideal living at Cornell Woods, offering apartments near Providence St. Vincent Hospital East Pavilion in Portland with great amenities.",
      "page_copy": "Cornell Woods presents an attractive option for those seeking apartments near Providence St. Vincent Hospital East Pavilion in Portland. Our location in Oak Hills ensures a convenient commute to the hospital, ideal for healthcare professionals and support staff who want proximity without sacrificing comfort.\n\nExperience the harmony of spacious living with our well-designed units that include generous closets and private patios or decks. Beyond the apartments, our community provides residents with access to a sparkling swimming pool, a children's playground, and a scenic courtyard equipped with picnic tables. At Cornell Woods, we blend convenience with comfort in a picturesque setting within Washington County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Providence St. Vincent Hospital",
      "seo_description": "Discover apartments near Providence St. Vincent Hospital East Pavilion at Cornell Woods. Ideal location with ample amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "apartments-near-providence-st-vincent-medical-center",
      "search_query": "apartments close to Providence St. Vincent Medical Center in Washington County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Providence St. Vincent Center",
      "h2_subtitle": "Cornell Woods offers apartments close to Providence St. Vincent Medical Center in Washington County, blending comfort with convenience.",
      "page_copy": "Cornell Woods is ideally situated for those in need of apartments close to Providence St. Vincent Medical Center in Washington County. Our strategic location in the scenic Oak Hills neighborhood makes it perfect for medical professionals and staff who prioritize both convenience and a peaceful living environment.\n\nOur community features a variety of amenities designed to enhance your living experience, including spacious closets, private patios or decks, and a refreshing swimming pool. Enjoy additional features like a dedicated playground and a courtyard with picnic tables, providing a relaxing atmosphere just minutes from the medical center. At Cornell Woods, experience the epitome of convenient and comfortable living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Providence St. Vincent Center",
      "seo_description": "Explore Cornell Woods for apartments close to Providence St. Vincent Medical Center. Enjoy Washington County living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "apartments-near-hoyt-arboretum-cornell-woods",
      "search_query": "apartments near Hoyt Arboretum Portland OR",
      "category": "Park",
      "h1_title": "Apartments Near Hoyt Arboretum Portland",
      "h2_subtitle": "Experience nature's beauty with apartments near Hoyt Arboretum Portland, OR. Cornell Woods offers serene living with modern conveniences.",
      "page_copy": "Cornell Woods provides an exceptional living experience for those seeking apartments near Hoyt Arboretum in Portland, OR. Our lovely location in the Oak Hills neighborhood offers residents easy access to the stunning trails and diverse plant species of the arboretum, perfect for nature enthusiasts and those seeking tranquility.\n\nResidents of Cornell Woods benefit from modern amenities like spacious closets and private decks or patios, ensuring comfort after a day spent in nature. The community features a refreshing swimming pool, a playground for children, and a picturesque courtyard with picnic tables, allowing you to unwind and enjoy outdoor activities right at home. Discover the perfect blend of nature and convenience at Cornell Woods.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hoyt Arboretum Portland",
      "seo_description": "Find comfort and nature together at Cornell Woods apartments near Hoyt Arboretum, Portland OR. Enjoy unique amenities and a scenic location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "washington-park-recreation-oak-hills-apartments",
      "search_query": "Washington Park recreational areas near Oak Hills apartments",
      "category": "Park",
      "h1_title": "Washington Park Areas Near Oak Hills Apartments",
      "h2_subtitle": "Explore Washington Park recreational areas near Oak Hills apartments at Cornell Woods for a blend of nature and convenience.",
      "page_copy": "Cornell Woods offers exceptional living for those interested in exploring Washington Park's recreational areas near Oak Hills apartments. Situated in a prime location, our community provides easy access to the lush landscapes and various attractions of Washington Park, making it perfect for outdoor lovers and families alike.\n\nAt Cornell Woods, enjoy the comfort of spacious closets, private patios, and decks, complemented by community amenities such as a swimming pool, a delightful playground, and a serene courtyard with picnic tables. Embrace a lifestyle that balances nature's beauty with modern convenience and comfort, all while being close to the recreational delights of Washington Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washington Park Areas Near Oak Hills Apartments",
      "seo_description": "Discover Washington Park's recreation near Oak Hills apartments at Cornell Woods, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "apartments-near-beaverton-tc-max-station-cornell-woods",
      "search_query": "apartments near Beaverton TC MAX Station Portland",
      "category": "Transit",
      "h1_title": "Apartments Near Beaverton TC MAX Station",
      "h2_subtitle": "Cornell Woods offers convenient apartments near Beaverton TC MAX Station, perfect for commuters in Portland.",
      "page_copy": "Cornell Woods is the ideal community for those looking for apartments near Beaverton TC MAX Station in Portland. Located in the charming Oak Hills neighborhood, our community provides easy access to public transportation, making it a great choice for commuters who value convenience and accessibility.\n\nResidents at Cornell Woods enjoy a range of amenities designed for comfort and ease. Spacious closets and private decks or patios enhance your living space, while community features such as a refreshing swimming pool, playground, and courtyard with picnic tables offer opportunities for relaxation and recreation. Discover the perfect balance of comfort and connectivity at Cornell Woods, just minutes from Beaverton TC MAX Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Beaverton TC MAX Station",
      "seo_description": "Discover Cornell Woods, apartments near Beaverton TC MAX Station. Experience easy commuting and great amenities in Portland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "cornell-woods-apts-by-quatama-transit",
      "search_query": "Cornell Woods apts by Quatama transit",
      "category": "Transit",
      "h1_title": "Cornell Woods Apts by Quatama Transit",
      "h2_subtitle": "Discover the convenience of Cornell Woods apts by Quatama transit, perfect for hassle-free commuting in the Portland area.",
      "page_copy": "Cornell Woods offers a prime location for those seeking apts by Quatama transit. Situated in the tranquil Oak Hills neighborhood of Portland, our community provides seamless access to the Quatama MAX Station, ensuring residents enjoy hassle-free commuting to work, school, or leisure destinations.\n\nOur residents benefit from spacious living arrangements, featuring ample closet space and private outdoor decks or patios. Enjoy relaxing at our on-site swimming pool, letting children play in the playground, or dining al fresco in the courtyard with picnic tables. Cornell Woods combines the serenity of suburban living with the advantages of easy access to public transportation, making it a sought-after spot near Quatama transit.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cornell Woods Apts by Quatama Transit",
      "seo_description": "Explore Cornell Woods, apts near Quatama transit. Enjoy easy travel and modern amenities in Portland's Oak Hills neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "orenco-max-apartments-washington-county",
      "search_query": "Orenco MAX apartments in Washington County",
      "category": "Transit",
      "h1_title": "Orenco MAX Apartments in Washington County",
      "h2_subtitle": "Cornell Woods offers convenient living near Orenco MAX apartments, nestled in beautiful Washington County, Portland.",
      "page_copy": "Located in the scenic Washington County, Cornell Woods provides comfortable living near Orenco MAX apartments. Our community is ideally positioned for those who desire convenient access to public transit, making the daily commute a breeze.\n\nCornell Woods offers a variety of amenities to complement your lifestyle, including spacious closets, private decks or patios, and a host of communal spaces like a swimming pool, a playground, and a charming courtyard with picnic tables. Experience the perfect blend of tranquility and convenience at Cornell Woods, where access to the Orenco MAX and the vibrant Portland environment meet.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Orenco MAX Apartments in Washington County",
      "seo_description": "Live near Orenco MAX in Washington County at Cornell Woods. Enjoy easy transit access and excellent amenities in Portland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166887",
      "source": "generator",
      "page_item_url": "elmonica-sw-170th-ave-transit-apartments-oak-hills",
      "search_query": "Elmonica SW 170th Ave transit apartments Oak Hills",
      "category": "Transit",
      "h1_title": "Elmonica Transit Apartments in Oak Hills",
      "h2_subtitle": "Discover Elmonica SW 170th Ave transit apartments located in the charming Oak Hills area, where convenience meets comfort.",
      "page_copy": "Cornell Woods brings you close to convenient Elmonica SW 170th Ave transit apartments in the serene Oak Hills neighborhood. Our location is ideal for those who desire quick and easy access to the MAX station, making daily commuting or weekend adventures hassle-free.\n\nEnjoy the rich amenities at Cornell Woods, designed to enhance your lifestyle. Residents have access to spacious closets, private patios or decks, and community features like a refreshing swimming pool, a playground, and a courtyard equipped with picnic tables. Experience the ideal mix of a peaceful neighborhood with the benefits of being near transit at Cornell Woods.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Transit Apartments Oak Hills",
      "seo_description": "Find Elmonica SW 170th Ave transit apartments in Oak Hills at Cornell Woods. Enjoy easy commuting and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "brianna@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5957"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372409721"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WPTHNDRN"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-840-1744 "
    }
  ],
  "custom_csm": "brianna@repli360.com",
  "custom_qb_id": "5957",
  "custom_repli_id": "18372409721",
  "custom_google_gtm_id": "GTM-WPTHNDRN",
  "custom_ads_subscription": "essential",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "none",
  "custom_ppc_tracking_phone_number": "844-840-1744 "
};

export const generatedAt = '2026-10-12T17:57:57.462Z';
